var map = {
	"./About": [
		847,
		987
	],
	"./About.js": [
		847,
		987
	],
	"./Books": [
		779,
		779
	],
	"./Books.js": [
		779,
		779
	],
	"./Layout": [
		311
	],
	"./Layout.js": [
		311
	],
	"./Welcome": [
		5,
		607
	],
	"./Welcome.js": [
		5,
		607
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 717;
module.exports = webpackAsyncContext;